var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguageSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 5.33333V21.3333C24 22.0667 23.7391 22.6947 23.2173 23.2173C22.6956 23.74 22.0676 24.0009 21.3333 24H2.66667C1.93333 24 1.30578 23.7391 0.784 23.2173C0.262222 22.6956 0.000888889 22.0676 0 21.3333V2.66667C0 1.93333 0.261333 1.30578 0.784 0.784C1.30667 0.262222 1.93422 0.000888889 2.66667 0H18.6667L24 5.33333ZM12 20C13.1111 20 14.0556 19.6111 14.8333 18.8333C15.6111 18.0556 16 17.1111 16 16C16 14.8889 15.6111 13.9444 14.8333 13.1667C14.0556 12.3889 13.1111 12 12 12C10.8889 12 9.94444 12.3889 9.16667 13.1667C8.38889 13.9444 8 14.8889 8 16C8 17.1111 8.38889 18.0556 9.16667 18.8333C9.94444 19.6111 10.8889 20 12 20ZM4 9.33333H16V4H4V9.33333Z",
    fill: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageSave);
export default __webpack_public_path__ + "static/media/languageSave.62511bf4b0f8cad29f6de9b24624da05.svg";
export { ForwardRef as ReactComponent };